import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: hidden;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: calc(100% - 48px);
  padding-bottom: 8px;

  display: flex;
  flex-direction: column;

  background: ${(props) => props.theme.colors.greys.lighter};
`;

export const SidePaddedGapContainer = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const FlexedGapContainer = styled.div`
  display: flex;
  column-gap: 24px;
`;

export const ListContainer = styled.div`
  height: 100%;
  width: 100%;

  position: relative;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;
`;

export const GridContainer = styled(Box)`
  max-height: calc(100% - 88px);
  width: 100%;
  padding: 0 24px;
`;

export const InlineFlexTypography = styled(Typography)`
  display: inline-flex;
  align-items: baseline;
`;

export const CenteredFlexBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderTooltipBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const HeaderTypography = styled(Typography)`
  font-size: 12px;
  word-break: break-word;
  white-space: normal;
`;

export const TreeCellTypography = styled(Typography)`
  font-size: 12px;
  padding-left: ${(props) => props.$paddingLeft || '0px'};
`;

export const TooltipIcon = styled.img`
  width: 12px;
  height: 12px;
  cursor: help;
`;

export const ExpandIcon = styled.img`
  width: 12px;
  height: 12px;
  transform: ${(props) => (props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

export const TooltipTypography = styled(Typography)`
  color: ${(props) => props.$theme?.colors?.greys?.lightest || '#fff'};
`;

export const DataGridStyles = (theme) => ({
  '& .MuiCircularProgress-root': {
    color: 'black',
  },
  marginTop: '24px',
  '& .MuiDataGrid-row.tree-depth-2 .MuiDataGrid-withBorderColor': {
    borderBottom: 'none !important',
    borderTop: 'none !important',
  },

  '& .MuiDataGrid-row.tree-depth-0': {
    backgroundColor: theme.colors.greys.lightest,
  },
  '& .MuiDataGrid-row.tree-depth-1': {
    backgroundColor: theme.colors.greys.lighter,
  },
  '& .MuiDataGrid-row.tree-depth-2': {
    backgroundColor: theme.colors.greys.lighter,
  },
  '& .MuiDataGrid-row.tree-row-clickable': {
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
});
